const RATES_FROM_UGX = {
  UGX: {
    symbol: 'UGX',
    rate: 1,
    locale: 'en-UG',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  USD: {
    symbol: '$',
    // Static fallback rate; adjust as needed from backend/admin when live rates are available.
    rate: 1 / 3800,
    locale: 'en-US',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  EUR: {
    symbol: '€',
    rate: 1 / 4100,
    locale: 'de-DE',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
  GBP: {
    symbol: '£',
    rate: 1 / 4800,
    locale: 'en-GB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
};

const cleanNumber = (value) => {
  if (value === null || value === undefined) return null;
  const numericValue =
    typeof value === 'string' ? Number(value.replace(/[^0-9.-]/g, '')) : Number(value);
  return Number.isNaN(numericValue) ? null : numericValue;
};

export const formatCurrency = (value, currency = 'UGX') => {
  const numericValue = cleanNumber(value);
  if (numericValue === null) {
    return 'Price Unavailable';
  }

  const cfg = RATES_FROM_UGX[currency] || RATES_FROM_UGX.UGX;
  const converted = numericValue * cfg.rate;

  if (currency === 'UGX') {
    return `${cfg.symbol} ${converted.toLocaleString(cfg.locale, {
      minimumFractionDigits: cfg.minimumFractionDigits,
      maximumFractionDigits: cfg.maximumFractionDigits,
    })}`;
  }

  return `${cfg.symbol}${converted.toLocaleString(cfg.locale, {
    minimumFractionDigits: cfg.minimumFractionDigits,
    maximumFractionDigits: cfg.maximumFractionDigits,
  })}`;
};

// Backwards compatibility export
export const formatUGX = (value) => formatCurrency(value, 'UGX');

export const getSupportedCurrencies = () => Object.keys(RATES_FROM_UGX);
